import React, { useState } from "react";
import "./Navbar.scss";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as ZixxarLogo } from "../../Assets/Global/zixxar-logo.svg";
import { ReactComponent as User } from "../../Assets/Global/user.svg";
import LoginModal from "../LoginModal/LoginModal";

import ButtonBuyTickets from "../../Views/BarcelonaEvent/Hero/Components/ButtonBuyTickets/ButtonBuyTickets";

const Navbar = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const loginModalToggler = () => setShowLoginModal(!showLoginModal);

  // const registerHandler = () => toast.info("Coming soon...");

  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <LoginModal show={showLoginModal} toggleModal={loginModalToggler} />

      <nav className={`navigation white-color ${isOpen ? "bg-black" : ""}`}>
        <div className="large-container d-flex align-items-center justify-content-between">
          <Link to="/">
            <ZixxarLogo
              className="cursor-pointer zixxar-logo"
              onClick={scrollToTop}
            />
          </Link>
          <div className="d-flex gap-2">
            <div className="d-flex d-md-none">
              <ButtonBuyTickets />
            </div>
            <User
              className="user-btn"
              onClick={() => window.open("https://shop.zixxar.net")}
            />
            <div
              className={`my-auto d-flex d-md-none hamburger ${
                isOpen ? "active" : ""
              }`}
              onClick={toggleMenu}
            >
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
              <ul className="font-pnr  menu vstack align-items-center navigation-items">
                {/* <a href='#event-agenda'>Agenda</a> */}
                <a href="#events-slider-section">Tickets</a>
                <a href="#maldive-events-cards">Events</a>
                {/* <a href="#event-banner">Location</a> */}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
